(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jquery"), require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define(["jquery", "React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["GoldenLayout"] = factory(require("jquery"), require("react"), require("react-dom"));
	else
		root["GoldenLayout"] = factory(root["$"], root["React"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return 